export enum EmergencyPlanActionParam {
    Text = 'text',
    Name = 'name',
    Phone = 'phone',
    Page = 'page',
    Location = 'locaton',
    Position = 'pos',
    Uri = 'uri',
}
